import { useEffect, useState } from "react";
import axios from "axios";
import { Cpu, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const prettyModel = (m) => {
  if (!m) return "AI";
  if (m.startsWith("gpt-5")) return m.replace("gpt-", "GPT-").toUpperCase().replace("GPT-5", "GPT-5");
  if (m.startsWith("gpt-4")) return m.replace("gpt-", "GPT-").toUpperCase();
  return m;
};

export default function AIStatusBadge() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/ai/status`)
      .then((r) => { if (alive) setStatus(r.data); })
      .catch(() => { if (alive) setStatus({ healthy: false, model: null, detail: "Unable to reach AI status" }); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  if (loading) {
    return (
      <div className="inline-flex items-center gap-1.5 rounded-full border border-[#DAD5CA] bg-[#FFFFFF] px-2.5 py-1 text-[11px] text-[#8A857A]" data-testid="ai-status-badge">
        <Loader2 className="w-3 h-3 animate-spin" /> AI…
      </div>
    );
  }

  const healthy = status?.healthy;
  const dot = healthy ? "#0E6B3F" : "#C23A00";
  const label = healthy ? prettyModel(status?.model) : "AI offline";
  const title = healthy
    ? `AI engine: OpenAI ${status?.model} — key healthy`
    : `AI unavailable${status?.detail ? `: ${status.detail}` : ""}`;

  return (
    <div
      className="inline-flex items-center gap-1.5 rounded-full border border-[#DAD5CA] bg-[#FFFFFF] px-2.5 py-1 text-[11px] text-[#59554D] cursor-default"
      title={title}
      data-testid="ai-status-badge"
      data-ai-healthy={healthy ? "true" : "false"}
    >
      <Cpu className="w-3 h-3 text-[#8A857A]" />
      <span className="font-medium text-[#1A1A1A]">{label}</span>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: dot }} data-testid="ai-status-dot" />
    </div>
  );
}
